import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { OpusAgentFieldsFragmentDoc } from '../opus-agent/agentPanel.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateOpusAgentMutationVariables = Types.Exact<{
  input: Types.OpusAgentInput;
}>;


export type CreateOpusAgentMutation = { __typename?: 'Mutation', createOpusAgent: { __typename?: 'OpusAgentResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, agent?: { __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null } | null } };

export type SetOpusAgentScheduleMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  input: Types.OpusAgentScheduleInput;
}>;


export type SetOpusAgentScheduleMutation = { __typename?: 'Mutation', setOpusAgentSchedule: { __typename?: 'OpusAgentResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, agent?: { __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null } | null } };

export type ClearOpusAgentScheduleMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type ClearOpusAgentScheduleMutation = { __typename?: 'Mutation', clearOpusAgentSchedule: { __typename?: 'OpusAgentResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, agent?: { __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null } | null } };

export type UpdateOpusAgentMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  input: Types.OpusAgentInput;
}>;


export type UpdateOpusAgentMutation = { __typename?: 'Mutation', updateOpusAgent: { __typename?: 'OpusAgentResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, agent?: { __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null } | null } };


export const CreateOpusAgentDocument = gql`
    mutation CreateOpusAgent($input: OpusAgentInput!) {
  createOpusAgent(input: $input) {
    success
    error {
      code
      message
    }
    agent {
      ...OpusAgentFields
    }
  }
}
    ${OpusAgentFieldsFragmentDoc}`;
export type CreateOpusAgentMutationFn = Apollo.MutationFunction<CreateOpusAgentMutation, CreateOpusAgentMutationVariables>;

/**
 * __useCreateOpusAgentMutation__
 *
 * To run a mutation, you first call `useCreateOpusAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpusAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpusAgentMutation, { data, loading, error }] = useCreateOpusAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpusAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpusAgentMutation, CreateOpusAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpusAgentMutation, CreateOpusAgentMutationVariables>(CreateOpusAgentDocument, options);
      }
export type CreateOpusAgentMutationHookResult = ReturnType<typeof useCreateOpusAgentMutation>;
export type CreateOpusAgentMutationResult = Apollo.MutationResult<CreateOpusAgentMutation>;
export type CreateOpusAgentMutationOptions = Apollo.BaseMutationOptions<CreateOpusAgentMutation, CreateOpusAgentMutationVariables>;
export const SetOpusAgentScheduleDocument = gql`
    mutation SetOpusAgentSchedule($id: UUID!, $input: OpusAgentScheduleInput!) {
  setOpusAgentSchedule(id: $id, input: $input) {
    success
    error {
      code
      message
    }
    agent {
      ...OpusAgentFields
    }
  }
}
    ${OpusAgentFieldsFragmentDoc}`;
export type SetOpusAgentScheduleMutationFn = Apollo.MutationFunction<SetOpusAgentScheduleMutation, SetOpusAgentScheduleMutationVariables>;

/**
 * __useSetOpusAgentScheduleMutation__
 *
 * To run a mutation, you first call `useSetOpusAgentScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOpusAgentScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOpusAgentScheduleMutation, { data, loading, error }] = useSetOpusAgentScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOpusAgentScheduleMutation(baseOptions?: Apollo.MutationHookOptions<SetOpusAgentScheduleMutation, SetOpusAgentScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOpusAgentScheduleMutation, SetOpusAgentScheduleMutationVariables>(SetOpusAgentScheduleDocument, options);
      }
export type SetOpusAgentScheduleMutationHookResult = ReturnType<typeof useSetOpusAgentScheduleMutation>;
export type SetOpusAgentScheduleMutationResult = Apollo.MutationResult<SetOpusAgentScheduleMutation>;
export type SetOpusAgentScheduleMutationOptions = Apollo.BaseMutationOptions<SetOpusAgentScheduleMutation, SetOpusAgentScheduleMutationVariables>;
export const ClearOpusAgentScheduleDocument = gql`
    mutation ClearOpusAgentSchedule($id: UUID!) {
  clearOpusAgentSchedule(id: $id) {
    success
    error {
      code
      message
    }
    agent {
      ...OpusAgentFields
    }
  }
}
    ${OpusAgentFieldsFragmentDoc}`;
export type ClearOpusAgentScheduleMutationFn = Apollo.MutationFunction<ClearOpusAgentScheduleMutation, ClearOpusAgentScheduleMutationVariables>;

/**
 * __useClearOpusAgentScheduleMutation__
 *
 * To run a mutation, you first call `useClearOpusAgentScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearOpusAgentScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearOpusAgentScheduleMutation, { data, loading, error }] = useClearOpusAgentScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearOpusAgentScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ClearOpusAgentScheduleMutation, ClearOpusAgentScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearOpusAgentScheduleMutation, ClearOpusAgentScheduleMutationVariables>(ClearOpusAgentScheduleDocument, options);
      }
export type ClearOpusAgentScheduleMutationHookResult = ReturnType<typeof useClearOpusAgentScheduleMutation>;
export type ClearOpusAgentScheduleMutationResult = Apollo.MutationResult<ClearOpusAgentScheduleMutation>;
export type ClearOpusAgentScheduleMutationOptions = Apollo.BaseMutationOptions<ClearOpusAgentScheduleMutation, ClearOpusAgentScheduleMutationVariables>;
export const UpdateOpusAgentDocument = gql`
    mutation UpdateOpusAgent($id: UUID!, $input: OpusAgentInput!) {
  updateOpusAgent(id: $id, input: $input) {
    success
    error {
      code
      message
    }
    agent {
      ...OpusAgentFields
    }
  }
}
    ${OpusAgentFieldsFragmentDoc}`;
export type UpdateOpusAgentMutationFn = Apollo.MutationFunction<UpdateOpusAgentMutation, UpdateOpusAgentMutationVariables>;

/**
 * __useUpdateOpusAgentMutation__
 *
 * To run a mutation, you first call `useUpdateOpusAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpusAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpusAgentMutation, { data, loading, error }] = useUpdateOpusAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpusAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpusAgentMutation, UpdateOpusAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpusAgentMutation, UpdateOpusAgentMutationVariables>(UpdateOpusAgentDocument, options);
      }
export type UpdateOpusAgentMutationHookResult = ReturnType<typeof useUpdateOpusAgentMutation>;
export type UpdateOpusAgentMutationResult = Apollo.MutationResult<UpdateOpusAgentMutation>;
export type UpdateOpusAgentMutationOptions = Apollo.BaseMutationOptions<UpdateOpusAgentMutation, UpdateOpusAgentMutationVariables>;